import script from "./DoughnutChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoughnutChart.vue?vue&type=script&lang=ts&setup=true"

import "./DoughnutChart.vue?vue&type=style&index=0&id=3088b1f0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3088b1f0"]])

export default __exports__